"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Swiper = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _ReactIdSwiper = _interopRequireDefault(require("react-id-swiper/lib/ReactIdSwiper.custom"));
require("swiper/swiper-bundle.min.css");
const Swiper = _ref => {
  let {
    swiperElement,
    swiperItems,
    swiperParams
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_ReactIdSwiper.default, (0, _extends2.default)({}, swiperParams, {
    ref: swiperElement
  }), swiperItems);
};
exports.Swiper = Swiper;
//# sourceMappingURL=Swiper.js.map